import { render, staticRenderFns } from "./websideworker.vue?vue&type=template&id=72f3c41c&scoped=true"
import script from "./websideworker.vue?vue&type=script&lang=js"
export * from "./websideworker.vue?vue&type=script&lang=js"
import style0 from "./websideworker.vue?vue&type=style&index=0&id=72f3c41c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3c41c",
  null
  
)

export default component.exports